import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import FunctionsData from "../../../Functions/FunctionsData";
import { Pagination, TextField } from '@mui/material';

export default function StaffDashboardOverview({ setCurrent, setLoadingArray, showActive, showInactive }) {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const history = useHistory();
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [filteredData, setFilteredData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [search, setSearch] = useState('');

    // Function to build URL based on active/inactive toggles
    const buildUrl = () => {
        let url = '/api/merco/all/summary_available';
        const params = [];

        if (showActive) {
            params.push("active=1");
        }
        if (showInactive) {
            params.push("inactive=1");
        }

        if (params.length > 0) {
            url += `?${params.join("&")}`;
        }

        const fullUrl = FunctionsData.getApiUrl(url);
        console.log("API URL:", fullUrl); // Log the full URL
        return fullUrl;
    };

    // Fetch data based on showActive and showInactive props
    useEffect(() => {
        console.log("Fetching data with active:", showActive, "inactive:", showInactive);

        setLoading(true);

        fetch(buildUrl())
            .then(response => response.json())
            .then(data => {
                console.log("Received data:", data);
                setData(data.data); // Update data state
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching data:", error);
                setLoading(false);
            });
    }, [showActive, showInactive]);

    // Update loading state
    useEffect(() => {
        setLoadingArray(!loading ? 0 : 1);
    }, [loading]);

    // Filter data based on search term and pagination
    useEffect(() => {
        let dataSearch = data.filter((row) => {
            return search === '' || row.campaign_name.toLowerCase().includes(search.toLowerCase());
        });
        setPageCount(Math.ceil(dataSearch.length / itemsPerPage));
        setFilteredData(dataSearch.slice((page - 1) * itemsPerPage, page * itemsPerPage));
    }, [data, page, search]);

    const handleChange = (event, value) => {
        setPage(value);
    };

    if (loading === true) return null;

    return (
        <div className="dashboard-box">
            <div className="header">
                Available vouchers
            </div>
            <div className="dashboard-content">
                <TextField
                    fullWidth
                    sx={{ marginBottom: 1 }}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    label="Filter campaigns"
                />
                {
                    filteredData?.map((row, idx) => {
                        return (
                            <div key={idx} style={{
                                borderBottom: (idx + 1 === data.length) ? null : '1px solid',
                                paddingBottom: (idx + 1 === data.length) ? null : 10,
                                marginBottom: (idx + 1 === data.length) ? null : 10
                            }}>
                                <p><strong>Campaign name</strong>: {row.campaign_name}</p>
                                <strong>Total</strong>: {row.total}
                                <span style={{ margin: '0 10px' }}>|</span>
                                <strong>Issued</strong>: {row.issued}
                                <span style={{ margin: '0 10px' }}>|</span>
                                <strong>Redeemed</strong>: {row.redeemed}
                                <span style={{ margin: '0 10px' }}>|</span>
                                <strong>Available</strong>: {row.total - row.issued}
                            </div>
                        )
                    })
                }
            </div>
            <div style={{ width: '100%', textAlign: 'right', marginBottom: 20 }}>
                <Pagination count={pageCount} page={page} onChange={handleChange} shape={"rounded"} />
            </div>
            <div className="footer">
                <a href={"#"} onClick={(e) => {
                    e.preventDefault();
                    setCurrent("/vouchers");
                    history.push('/vouchers');
                }}>See all vouchers</a>
            </div>
        </div>
    );
}
